import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {StartComponent} from './pages/start/start.component';
import { SharedModule } from "./shared/shared.module";
import {MatIcon} from '@angular/material/icon';
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { QuestionComponent } from './pages/question/question.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ScoreComponent } from './pages/score/score.component';
import { ScoreboardCardComponent } from './components/scoreboard-card/scoreboard-card.component';
import { DividerComponent } from './components/divider/divider.component';
import {NgOptimizedImage} from '@angular/common';
import { InstructionsComponent } from './pages/instructions/instructions.component';
import { QuizDoneComponent } from './pages/quiz-done/quiz-done.component';
import { SplashComponent } from './pages/splash/splash.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { QuestionConfigComponent } from './pages/question-config/question-config.component';
import { AddQuestionDialogComponent } from './pages/question-config/add-question-dialog/add-question-dialog.component';
import { ScoreConfigComponent } from './pages/score-config/score-config.component';
import { ScoreIntroComponent } from './pages/score-intro/score-intro.component';
import { MiscSettingsComponent } from './pages/misc-settings/misc-settings.component';
import { QuizCooldownComponent } from './pages/quiz-cooldown/quiz-cooldown.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    SignUpComponent,
    QuestionComponent,
    ProgressBarComponent,
    ScoreComponent,
    ScoreboardCardComponent,
    DividerComponent,
    InstructionsComponent,
    QuizDoneComponent,
    SplashComponent,
    AdminComponent,
    ConfigurationComponent,
    QuestionConfigComponent,
    AddQuestionDialogComponent,
    ScoreConfigComponent,
    ScoreIntroComponent,
    MiscSettingsComponent,
    QuizCooldownComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MatIcon,
    NgOptimizedImage,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
